import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { Loading } from '../common/Loading';
import { ROUTES } from '../../utils/constants';
import type { User } from '../../types/user';

interface AuthGuardProps {
  children: React.ReactNode;
  tenant: string;
  requireRole?: User['role'][];
}

export function AuthGuard({ children, tenant, requireRole }: AuthGuardProps) {
  const { user, isLoading, isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <Loading fullScreen message="Loading..." />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.login(tenant)} state={{ from: location }} replace />;
  }

  if (requireRole && !requireRole.includes(user.role)) {
    // Redirect to home if user doesn't have required role
    return <Navigate to={ROUTES.home(tenant)} replace />;
  }

  return <>{children}</>;
}
